var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _g, _path0, _path1, _path10;

function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }

import * as React from "react";

function SvgImgDocument(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 60,
    viewBox: "0 0 48 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.116 58.854l-.503.091c-.236.046-.487.084-.739.13-.61.091-1.25.182-1.92.259H4.82a4.15 4.15 0 01-4.152-4.145V20.667C1.429 6.137 3.677 2 15.143.667h14.94v9.867c0 3.162 1.852 4.8 4.146 4.8h-.587c.853 33.577 3.589 41.12-8.526 43.52z",
    fill: "#D6EAED"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M38.694 51.479s-.93 7.855-7.711 7.855h-8.122a14.46 14.46 0 002.773-.594c.008.007.023 0 .03-.008 9.768-7.314 6.782-27.444 4.946-45.63v.007c.708 1.47 2.064 2.225 3.619 2.225l4.426.312.03 35.833h.008z",
    fill: "#A9CED4"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.143.667C3.676 2 1.429 6.137.667 20.667V4.812A4.15 4.15 0 014.819.667h10.324z",
    fill: "#D7F5F7"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M47.334 58A1.34 1.34 0 0146 59.334h-6.705a4.113 4.113 0 003.863-2.667H46c.366 0 .701.145.937.396.244.244.397.572.397.937z",
    fill: "#E5E5E5"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M30.084 9.87V.668L43.44 14.023h-9.212a4.144 4.144 0 01-4.144-4.145v-.007z",
    fill: "#2560DD"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M18.084 16.667H7.25c-.69 0-1.25.56-1.25 1.25v8.167c0 .69.56 1.25 1.25 1.25h10.834c.69 0 1.25-.56 1.25-1.25v-8.168c0-.69-.56-1.249-1.25-1.249z",
    fill: "#DB0000"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M15.79 21.246l-4.914-2.842a.584.584 0 00-.876.503v5.676c0 .45.488.732.876.503l4.915-2.842a.586.586 0 000-1.013v.015z",
    fill: "#D6EAED"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M25.49 26h-3.117a.377.377 0 01-.38-.38v-1.905c0-.206.167-.381.38-.381h2.766c.122.891.236 1.783.343 2.667h.008zM26.602 43.334a4.19 4.19 0 01-.152.67c-.214.656-.45 1.326-.709 1.997h-3.36A.382.382 0 0122 45.62v-1.905c0-.213.168-.381.381-.381h4.22z",
    fill: "#4589FF"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M30.953 26H25.49c-.115-.883-.229-1.775-.35-2.666h5.805c.213 0 .38.175.38.38v1.906a.377.377 0 01-.38.38h.008zM31.333 43.715v1.905a.382.382 0 01-.38.38H25.74c.259-.67.495-1.348.709-1.995.06-.191.114-.404.152-.671h4.35c.214 0 .381.168.381.38zM31.394 20.667h-9.013a.377.377 0 01-.381-.381V18.38c0-.213.168-.381.381-.381h8.739l.274 2.667zM32.522 38c0 .907-.023 1.79-.061 2.667h-10.08a.382.382 0 01-.381-.381V38.38c0-.213.168-.381.381-.381h10.14z",
    fill: "#4589FF"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M19.333 37.917v7.33l-2.78-2.782a.797.797 0 00-.542-.236.776.776 0 00-.61.236l-2.155 2.156L10 41.377a.886.886 0 00-.457-.252.964.964 0 00-.937.26L6.008 43.98v-6.057c0-.685.563-1.25 1.25-1.25h10.841c.693 0 1.25.557 1.25 1.25l-.016-.007z",
    fill: "#6BBDF7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.3 41.673a1.577 1.577 0 100-3.154 1.577 1.577 0 000 3.154z",
    fill: "#FCD222"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.996 47.364l-6.666-.03-2.195-.016a1.233 1.233 0 01-1.143-1.234v-2.11l2.599-2.598c.251-.26.609-.35.937-.26a.689.689 0 00-.176-.022l.618 3.26.777-.258.8 2.994 1.699-2.453-.023-.023 2.156-2.156a.825.825 0 01.61-.237l.525 2.774.67-.221.679 2.552h-1.92l.03.03.023.008z",
    fill: "#007B00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.269 44.63l-1.7 2.46-.8-2.994-.784.259-.617-3.253a.89.89 0 01.632.274l3.261 3.26.008-.007zm3.283-2.172a.797.797 0 00-.54-.236l.525 2.773.67-.221.679 2.552h.198a1.25 1.25 0 001.25-1.25v-.845l-2.782-2.78v.007z",
    fill: "#012B0A"
  }))), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M41.292 16.035v38.179s-.313 5.12-2.599 5.12h-7.71c6.781 0 7.71-7.855 7.71-7.855l-.03-35.833-4.427-.312c-2.293 0-4.152-1.638-4.152-4.8v-.663a4.157 4.157 0 004.152 4.152h5.692s1.364.907 1.364 2.012z",
    fill: "#6D91AB"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M43.44 14.023V55.19c0 .8-.22 1.547-.61 2.18a4.12 4.12 0 01-1.615 1.492 4.038 4.038 0 01-1.912.473h-.61c2.286 0 2.599-5.12 2.599-5.12v-38.18c0-1.104-1.364-2.01-1.364-2.01h3.512z",
    fill: "#405366"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M37.619 38h-5.097c0 .907-.023 1.79-.061 2.667h5.158a.382.382 0 00.381-.381V38.38a.377.377 0 00-.381-.381zM37.62 18h-6.5l.274 2.667h6.225c.214 0 .381-.168.381-.381V18.38a.377.377 0 00-.38-.381z",
    fill: "#2560DD"
  })));
}

export default SvgImgDocument;